import type { PlaceLevel } from "@/entities/place";
import { PLACE_LEVEL } from "@/entities/place";

export const getExactnessButtonLabelKey = (level: PlaceLevel | null): string => {
    switch (level) {
        case PLACE_LEVEL.Country:
        case PLACE_LEVEL.StateRegion:
            return "location.exactness.exactToCountry";
        default:
            return "location.exactness.exact";
    }
};

export const getExactnessSingleSelectLabelKey = (
    level: PlaceLevel | null,
    selectedOptionFullLabelKey: string | null,
): string => {
    switch (level) {
        case null:
        case PLACE_LEVEL.Continent:
        case PLACE_LEVEL.CountryRegion:
            return "location.exactness.exact";
        case PLACE_LEVEL.Country:
        case PLACE_LEVEL.StateRegion:
            return "location.exactness.exactToCountry";
        default:
            if (!selectedOptionFullLabelKey) return "location.exactness.exactTo";
            return selectedOptionFullLabelKey;
    }
};
